import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("wm_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function money(n) {
  const v = Number(n || 0);
  return `$${v.toFixed(v % 1 === 0 ? 0 : 2)}`;
}

export function imgUrl(u) {
  if (!u) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
}

export function telHref(phone) {
  const digits = String(phone || "").replace(/[^0-9+]/g, "");
  return `tel:${digits.startsWith("+") ? digits : "+1" + digits.replace(/^1/, "")}`;
}

export function smsHref(phone) {
  const digits = String(phone || "").replace(/[^0-9+]/g, "");
  return `sms:${digits.startsWith("+") ? digits : "+1" + digits.replace(/^1/, "")}`;
}

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
